import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "HomeViewContainer" */ './container/HomeViewContainer'));
